/* Product gallery arrows and thumbnail rail (2026-10-10).
   On desktop the thumbnails sit in a rail beside the photo (snippets/ch-gallery-fit.liquid).
   This adds previous / next arrows and a counter on the photo, keeps the active thumbnail
   in view inside the rail, and marks the rail when it has more above or below. */
(function () {
  var desktop = window.matchMedia('(min-width: 990px)');
  var CHEVRON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';

  function init(gallery) {
    if (gallery.dataset.chGalReady) return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var rail = gallery.querySelector('[id^="GalleryThumbnails"]');
    var list = rail && rail.querySelector('.thumbnail-list');
    if (!viewer || !list) return;
    gallery.dataset.chGalReady = 'true';

    /* Thumbnails of the 3D models for the other sizes are in the list but hidden. */
    function items() {
      return Array.prototype.filter.call(list.querySelectorAll('li[data-target]'), function (item) {
        return window.getComputedStyle(item).display !== 'none';
      });
    }

    function activeIndex(all) {
      for (var i = 0; i < all.length; i++) {
        if (all[i].querySelector('button[aria-current]')) return i;
      }
      return 0;
    }

    /* Goes through the thumbnail's own click, so the theme's gallery does the switch. */
    function step(by) {
      var all = items();
      if (all.length < 2) return;
      all[(activeIndex(all) + by + all.length) % all.length].querySelector('button').click();
    }

    function arrow(name, label, by) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ch-gal-arrow ch-gal-arrow--' + name + ' quick-add-hidden';
      button.setAttribute('aria-label', label);
      button.innerHTML = CHEVRON;
      button.addEventListener('click', function () {
        step(by);
      });
      viewer.appendChild(button);
    }

    arrow('prev', 'Previous photo', -1);
    arrow('next', 'Next photo', 1);

    var count = document.createElement('div');
    count.className = 'ch-gal-count quick-add-hidden';
    count.setAttribute('aria-hidden', 'true');
    viewer.appendChild(count);

    function markRail() {
      var more = desktop.matches && list.scrollHeight - list.clientHeight > 4;
      rail.toggleAttribute('data-ch-more-up', more && list.scrollTop > 4);
      rail.toggleAttribute('data-ch-more-down', more && list.scrollTop + list.clientHeight < list.scrollHeight - 4);
    }

    function sync() {
      var all = items();
      var index = activeIndex(all);
      var item = all[index];
      count.textContent = index + 1 + ' / ' + all.length;

      if (item && desktop.matches) {
        var top = item.offsetTop;
        var bottom = top + item.offsetHeight;
        if (top < list.scrollTop) list.scrollTop = top - 8;
        else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight + 8;
      }
      markRail();
    }

    new MutationObserver(sync).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
    list.addEventListener('scroll', markRail, { passive: true });
    window.addEventListener('resize', sync);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.setTimeout(sync, 0);
      });
    }
    sync();
  }

  function boot() {
    document.querySelectorAll('media-gallery[data-ch-rail]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
